import * as ko from "knockout";

import { AuthMethod, AuthState } from "./contracts";
import { ViewId } from "./configuration";

class AuthViewModel {

  // Computed properties - initialized in constructor
  showCookieConsent: ko.PureComputed<boolean>;
  showAuthPanel: ko.PureComputed<boolean>;
  showMethodListPanel: ko.PureComputed<boolean>;
  showUserPanel: ko.PureComputed<boolean>;
  selectedMethod: ko.PureComputed<AuthMethod | null>;

  constructor() {
    global.Logonme.log("AuthViewModel:constructor");

    // Initialize computed properties
    this.showCookieConsent = ko.pureComputed<boolean>(() => !global.Logonme.HasConsent());
    this.showAuthPanel = ko.pureComputed<boolean>(() => global.Logonme.HasConsent() && global.Logonme.ActiveView() === ViewId.Auth);
    this.showMethodListPanel = ko.pureComputed<boolean>(() => global.Logonme.HasConsent() && global.Logonme.ActiveView() === ViewId.Methods);
    this.showUserPanel = ko.pureComputed<boolean>(() => global.Logonme.HasConsent() && global.Logonme.ActiveView() === ViewId.Home);
    this.selectedMethod = ko.pureComputed<AuthMethod | null>(() => global.Logonme.SelectedMethod());

    this.selectedMethod.subscribe((method: AuthMethod | null) => {
      if (method === null) {
        const authState = global.Logonme.AuthState();
        if (authState === AuthState.PathCancelled) {
          global.Logonme.LastLoginStore.remove();
          global.Logonme.log(`last-login-cleared for ${authState}`);
        }
      } else {
        if (method.id !== null) {
          global.Logonme.LastLoginStore.set(method);
          global.Logonme.log(`last-login-set for ${method.id}`);
        }
      }
    });

    global.Logonme.ViewConstructedCount(global.Logonme.ViewConstructedCount() + 1);
  }

  doChangeLanguage(language: string): void {
    global.Logonme.log(language);
    global.Logonme.SelectedLanguage(language);
  }

  doAfterRender(): void {
    global.Logonme.log("doAfterRender");
  }
}

export { AuthViewModel };
